import { defineAction } from '~/prix'
import { z } from 'zod'
import machineServiceDeleteAction from './machineServiceDelete.action.json' with { type: 'json' }

const machineServiceDeleteDefinition = defineAction({
  ...machineServiceDeleteAction,

  input: z.object({
    id: z.string().uuid(),
  }),
  output: z.object({}),
})

export default machineServiceDeleteDefinition
